import React, {useEffect, useState} from "react";
import api from "../api";
import {Card, Col, Row, Spin, Radio, Typography,  Breadcrumb, Button} from "antd";
import './quiz.sass';
import { useSelector} from "react-redux";
import QuizItem from "./Fragments/QuizItem";
import {Helmet} from "react-helmet-async";
import {Trans, useTranslation} from "react-i18next";
import ChatPromoBanner from "../Fragments/ChatPromoBanner";

import DynamicAdBanner from "../DynamicAddBanner";
import {useNavigate} from "react-router-dom";
import {ThunderboltOutlined} from "@ant-design/icons";

const { Title } = Typography;

function Quizes({analytics}){
    const [quizes,setQuizes] = useState([])
    const [loading,setLoading] = useState(true)
    const [filter, setFilter] = useState('all');
    const RQuizes = useSelector(({quizes})=>quizes)
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(()=>{
        analytics()
        api.API.get(api.Quize).then((data)=>{
           setQuizes(data)
            setLoading(false)
        })
    },[])

    const filteredQuizes = quizes.filter(q => {
        if (filter === 'all') return true;
        const score = RQuizes[q.id];
        if (filter === 'passed') return score >= 18;
        if (filter === 'failed') return score !== undefined && score < 18;
        if (filter === 'not_started') return score === undefined;
        return true;
    });

    return(<div>
        <Helmet>
            <title>{t('seo.quizes_title')}</title>
            <meta name="description" content={t('seo.quizes_desc')} />
        </Helmet>

        <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
            <Col span={24}>
                <Card 
                    size="small"
                    style={{ 
                        borderRadius: 12, 
                        background: 'linear-gradient(90deg, #f5222d 0%, #722ed1 100%)',
                        border: 'none',
                        cursor: 'pointer'
                    }}
                    onClick={() => navigate('/battle')}
                >
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '8px 0', gap: 15 }}>
                        <ThunderboltOutlined style={{ color: '#fff', fontSize: 20 }} />
                        <p strong style={{ color: '#fff' }}>{t('battle.mode_title')} - {t('battle.mode_desc')}</p>
                        <Button size="small" style={{ borderRadius: 6, fontWeight: 'bold', color: '#722ed1' }}>
                            {t('battle.start_btn')}
                        </Button>
                    </div>
                </Card>
            </Col>
        </Row>
        
        <div style={{ marginBottom: 20, textAlign: 'center' }}>
            <Title level={2} className="page-title"><Trans i18nKey={'questions.tests'}>Հարցաշար</Trans></Title>
            {/*<DynamicAdBanner bannerId="6112568" />*/}
            {/* Desktop Filter */}
            <div className="desktop-filter">
                <Radio.Group value={filter} onChange={e => setFilter(e.target.value)} buttonStyle="solid">
                    <Radio.Button value="all">{t('quiz_filter.all')}</Radio.Button>
                    <Radio.Button value="not_started">{t('quiz_filter.not_started')}</Radio.Button>
                    <Radio.Button value="passed">{t('quiz_filter.passed')}</Radio.Button>
                    <Radio.Button value="failed">{t('quiz_filter.failed')}</Radio.Button>
                </Radio.Group>
            </div>

            {/* Mobile Breadcrumb Filter */}
            <div className="mobile-breadcrumb-filter">
                <div className="breadcrumb-scroll">
                    <span className={filter === 'all' ? 'active' : ''} onClick={() => setFilter('all')}>{t('quiz_filter.all')}</span>
                    <span className="sep">/</span>
                    <span className={filter === 'not_started' ? 'active' : ''} onClick={() => setFilter('not_started')}>{t('quiz_filter.not_started')}</span>
                    <span className="sep">/</span>
                    <span className={filter === 'passed' ? 'active' : ''} onClick={() => setFilter('passed')}>{t('quiz_filter.passed')}</span>
                    <span className="sep">/</span>
                    <span className={filter === 'failed' ? 'active' : ''} onClick={() => setFilter('failed')}>{t('quiz_filter.failed')}</span>
                </div>
            </div>
        </div>

        <Spin spinning={loading}>
            <Row gutter={[16, 16]}>
                {filteredQuizes?.map(i => (
                    <Col lg={6} md={8} sm={12} xs={12} key={i.id}>
                        <QuizItem RQuizes={RQuizes} id={i.id} number={i.number}/>
                    </Col>
                ))}
            </Row>
        </Spin>
    </div>)
}
export default Quizes;
